var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBelowNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    rx: 2,
    transform: "rotate(-180 20 20)",
    fill: "#ABC3DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7465 11.403C13.5154 11.1719 13.1414 11.1723 12.9107 11.403L10.5763 13.7374L10.5763 6.80607C10.5763 6.47926 10.3122 6.21515 9.98535 6.21515C9.65855 6.21515 9.39443 6.47926 9.39443 6.80607L9.39443 13.7374L7.06001 11.403C6.82891 11.1719 6.45489 11.1723 6.2242 11.403C5.99352 11.6337 5.9931 12.0077 6.2242 12.2388L9.56745 15.5821C9.79855 15.8132 10.1726 15.8128 10.4033 15.5821L13.7465 12.2388C13.9772 12.0082 13.9776 11.6341 13.7465 11.403Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 5,
    width: 14,
    height: 0.999999,
    rx: 0.499999,
    transform: "rotate(-180 17 5)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelowNormal);
export default __webpack_public_path__ + "static/media/below_normal.62817b917c11b6511ae55fd36bbc519f.svg";
export { ForwardRef as ReactComponent };